<template>
  <Load />
  <sidenav
    :custom_class="this.$store.state.mcolor"
    :class="[
      this.$store.state.isRTL ? 'fixed-end' : 'fixed-start',
    ]"
    v-if="this.$store.state.showSidenav"
  />
  <main
    class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
  >
    <!-- nav -->
    <navbar
      :class="[navClasses]"
      :textWhite="this.$store.state.isAbsolute ? 'text-white opacity-8' : ''"
      :minNav="navbarMinimize"
      v-if="this.$store.state.showNavbar"
    />
    <router-view />
    <app-footer v-show="this.$store.state.showFooter" />
    <configurator
      :toggle="toggleConfigurator"
      :class="[
        this.$store.state.showConfig ? 'show' : '',
        this.$store.state.hideConfigButton ? 'd-none' : '',
      ]"
    />
  </main>

  <!-- AI Assistant Chat Bubble -->
  <AIChatBubble v-if="isLoggedIn" />
</template>

<script>
import Sidenav from "./Sidenav";
import Configurator from "./Configurator.vue";
import Navbar from "./Navbar.vue";
import AppFooter from "./Footer.vue";
import { mapMutations, mapGetters } from "vuex";
import Load from "./Load.vue";
import AIChatBubble from "@/components/AIAssistant/AIChatBubble.vue";

export default {
  name: "App",
  components: {
    Sidenav,
    Configurator,
    Navbar,
    AppFooter,
    Load,
    AIChatBubble,
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
  },
  computed: {
    ...mapGetters(["ApiToken"]),
    isLoggedIn() {
      return !!this.ApiToken;
    },
    navClasses() {
      return {
        "position-sticky mt-4 left-auto top-1 z-index-sticky": this
          .$store.state.isNavFixed,
        "position-absolute px-4 mx-0  z-index-2": this.$store.state
          .isAbsolute,
        "px-0 mx-4 mt-4": !this.$store.state.isAbsolute,
      };
    },
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";
  },
};
</script>

<style>

</style>